import { jsxs, jsx } from 'react/jsx-runtime';
import { useWindowSize, BREAKPOINTS_WIDTHS } from '@belong/common';
import clsx from 'clsx';
import css from './Stepper.module.css.js';

function Stepper({
  steps,
  onlyActiveLabel,
  onStepSelection
}) {
  const {
    width
  } = useWindowSize();
  const isMobile = width <= BREAKPOINTS_WIDTHS.MD;
  const activeStep = steps.find(step => step.active);
  const activeStepIndex = steps.indexOf(activeStep) || 0;
  const stepsLength = steps.length + 1;
  const stepIndividualBasis = 100 / stepsLength;
  // If we want to show the current step as "completed", we should increment the index by 1
  // Formula: (100 / stepsQuantity) * (currentStepIndex + 1)
  // Example of 60%: (100 / 5) * (2 + 1) = 60% of completion, ie, completed until 3rd step from a collection of 5 steps
  const percentageOfCompletion = stepIndividualBasis * (activeStepIndex + 1);
  const onSelection = (step, index) => e => {
    e.stopPropagation();
    if (onStepSelection) onStepSelection(step, index);
  };
  const shouldShowLabel = step => {
    if (isMobile) {
      return step === activeStep;
    }
    return onlyActiveLabel && step === activeStep || !onlyActiveLabel;
  };
  return jsxs("div", {
    className: "flex w-full flex-col",
    children: [jsxs("section", {
      className: "flex w-full flex-row",
      style: {
        zIndex: 1,
        transform: 'translateY(5px)'
      },
      children: [steps.map((step, index) => {
        const isStepCompleted = index < activeStepIndex;
        return jsxs("article", {
          className: clsx('flex flex-col-reverse', {
            'cursor-pointer': !!onStepSelection
          }),
          style: {
            width: `${stepIndividualBasis}%`
          },
          onClick: onSelection(step, index),
          children: [jsx("div", {
            className: clsx('h-2xs w-2xs self-end rounded bg-green', css.indicator, {
              [`${css.active}`]: step.active
            })
          }), shouldShowLabel(step) && jsx("div", {
            className: clsx('place-content-center self-end text-navy', 'mb-2xs w-[200%] translate-x-1/2 whitespace-nowrap text-center text-p2 leading-p2 md:w-full', {
              'font-semibold': step.active || isStepCompleted
            }),
            children: step.label
          })]
        }, `${step.label}-${index}`);
      }), jsx("article", {
        className: "flex",
        style: {
          width: `${stepIndividualBasis}%`
        }
      })]
    }), jsx("div", {
      className: clsx('w-full rounded bg-light-gray', css.progressBar)
    }), jsx("div", {
      className: clsx('rounded-l bg-navy', css.progressBar),
      style: {
        width: `${percentageOfCompletion}%`,
        transform: 'translateY(-100%)'
      }
    })]
  });
}

export { Stepper };
